import _ from "lodash"
import Helpers from "@/lib/helpers";
import helpers from "@/lib/helpers";

const state = {
    settings: {},
    defaults: {},
    permissions: []
}

const getters = {
    get_setting: (state) => (type) => {
        return state.settings[type]
    },
    defaults_loaded: (state) => {
        return Object.keys(state.defaults).length > 0
    },
    can: (state) => (permission) => {
        return state.permissions.indexOf(permission) >= 0
    }
}

const mutations = {
    load_defaults: (state, defaults) => state.defaults = defaults,
    set_defaults: (state, payload) => {
        state.defaults[payload.type] = payload.value
    },

    load_settings(state, settings) {
        state.settings = {...state.settings, ...settings}
    },

    load_permissions(state, permissions) {
        if (!_.isEqual(_.sortBy(_.uniq(state.permissions || [])), _.sortBy(_.uniq(permissions))))
            state.permissions = permissions
    },

    set_setting(state, payload) {
        state.settings[payload.type] = payload.value
    }
}

const actions = {
    async set_profile({state, commit}, profile) {
        if (state.defaults.profiles[profile] === undefined)
            throw new Error('Invalid profile: ' + profile)

        commit('load_settings', state.defaults.profiles[profile])
    },

    /** just the ship services again: a freight quote adds one for each trucking line it sees first */
    async shipping_refresh({commit}) {
        const shipping = await Helpers.asyncAction('/api/settings/shipping', 'get', {noload: true, quiet: true})
        commit('set_defaults', {type: 'shipping', value: shipping})
    },

    async settings_load({commit}) {
        const defaults = await Helpers.asyncAction('/api/settings', 'get', {no_perm_hash: true, toast: true, noload: false, quiet: true})

        await commit('load_defaults', defaults)

        const settings = await Helpers.asyncAction('/api/user/self/settings', 'get', {no_perm_hash: true, toast: true})
        commit('load_settings', settings.settings)
        commit('load_permissions', settings.permissions)

        let users = []
        if (helpers.can('users.index'))
            users = await Helpers.asyncAction('/api/user', 'get', {no_perm_hash: true, toast: true, noload: false})

        await commit('set_defaults', {type: 'users', value: users})
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}